import { ThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import { StoreProvider } from '#store';
import theme from '#theme';
import Views from '#views';
import { Modal, ErrorBoundary } from '#components';

const App = () => (
  <React.StrictMode>
    <ErrorBoundary>
      <StoreProvider>
        <CssBaseline />
        <ThemeProvider theme={theme}>
          <Modal />
          <SnackbarProvider
            maxSnack={5}
            anchorOrigin={{
              vertical  : 'bottom',
              horizontal: 'center',
            }}
          >
            <Router>
              <Views />
            </Router>
          </SnackbarProvider>
        </ThemeProvider>
      </StoreProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

export default App;
